/** Student or parent, chosen once after signing in without an account. */
export type Role = "student" | "parent";

const KEY = (uid: string) => `dueable.role.${uid}`;

/** The choice is remembered on this device only (a convenience: a parent isn't asked every time). */
export function rememberedRole(uid: string): Role | null {
  try {
    const value = localStorage.getItem(KEY(uid));
    return value === "student" || value === "parent" ? value : null;
  } catch {
    return null;
  }
}

export function rememberRole(uid: string, role: Role | null) {
  try {
    if (role) localStorage.setItem(KEY(uid), role);
    else localStorage.removeItem(KEY(uid));
  } catch {
    // Storage blocked (private window): the choice just isn't remembered.
  }
}
